import { Stack, styled } from '@mui/system';

export const SquareCard = styled(Stack)(({ theme }) => ({
  alignItems: 'center',
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.spacing(1),
  minWidth: theme.spacing(5.75),
  maxWidth: theme.spacing(5.75),
  height: theme.spacing(5.75),
}));
